<template lang="pug">
    a.battles-banner(target="_blank" :href="link")
        img.battles-banner__gif(src="gifs/bnr-2025.gif")
</template>

<script>
    export default {
        computed: {
            link() {
                return 'https://cleverstart.ru/championship_2025';
            },
        },
    };
</script>

<style lang="scss" scoped>
    .battles-banner {
        display: block;
        overflow: hidden;
        cursor: pointer;

        border-radius: $border-radius-20;
        background-color: $x-color-white;
    }
    .battles-banner__gif {
        width: 100%;
        outline: 2px solid $hsl-color-gray-98;
        outline-offset: -2px;
    }
</style>
